import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import { Container, Content, Profile } from "./styles.js"
import logo from '../../assets/logos/logo.svg'
import {toast} from 'react-toastify'

import { Dropdown, DropdownItem, DropdownToggle, DropdownMenu, Nav } from 'reactstrap';

import {AuthContext} from '../../context/AuthContext'

export default function HeaderDefault(){

    const { singOut } = useContext(AuthContext)

    async function handleClick(){

        try {
            singOut()
        } catch (error) {
            let erro = JSON.parse(error.request.response)
            toast.error(erro.error)
        }

    }

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen(!dropdownOpen);
    const { user } = useContext(AuthContext)
    return (
        <Container>
            <Content>
                <nav>
                    <Link to="/dashboard" title="Ir para Dashboard">
                        <img src={logo} alt="Carol Nutri" />
                    </Link>
                </nav>

                <aside>
                    <Profile>
                        <Nav pills>
                            <Dropdown nav isOpen={dropdownOpen} toggle={toggle}>
                                <DropdownToggle nav caret className="drop">
                                    {user.name}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <Link to="/perfil" title="Ir para seu perfil">
                                        <DropdownItem className="dropOption">
                                            Perfil
                                        </DropdownItem>
                                    </Link>
                                    <DropdownItem divider />
                                    <DropdownItem onClick={handleClick} className="dropOption">
                                        Logout
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                            </Nav>
                            <div style={{ background: `url(${user.avatar}) center no-repeat`}}/>
                    </Profile>
                </aside>
            </Content>
        </Container>
    )
}
